import React from 'react';
import { StyledTableHeader } from '../../../styledComponents';

export type TableHeaderProps = {
  label: string;
  icon: React.ReactNode;
};

export const TableHeader = ({ label, icon }: TableHeaderProps) => {
  return (
    <StyledTableHeader>
      {icon}
      <p>{label}</p>
    </StyledTableHeader>
  );
};
